import { render } from "./ProfileImg.vue?vue&type=template&id=4f5d26cc&scoped=true"
import script from "./ProfileImg.vue?vue&type=script&lang=js"
export * from "./ProfileImg.vue?vue&type=script&lang=js"

import "./ProfileImg.vue?vue&type=style&index=0&id=4f5d26cc&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5d26cc"]])

export default __exports__